import React from 'react';
import { Query, QueryComponentOptions } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';

import query, { MySelectionLoaderQuery } from './my-selection.graphql';
import MySelection from './my-selection';
import defaultStyles from './my-selection-loader.scss';

export interface Props {
    styles: typeof defaultStyles;
    refetchQueries: Array<string | QueryComponentOptions>;
}

class MySelectionLoader extends React.PureComponent<Props> {
    render() {
        const { styles, refetchQueries } = this.props;
        return (
            <Query<MySelectionLoaderQuery> query={query} notifyOnNetworkStatusChange={true}>
                {({ error, data, loading, refetch }) => {
                    if (data && data.selectionItems) {
                        return <MySelection selectionItems={data.selectionItems} refetchQueries={refetchQueries} />;
                    }

                    if (error) {
                        return (
                            <LoadingWrapperView loading={loading}>
                                <div className={styles.error}>
                                    <FormattedMessage id='THERE_IS_A_PROBLEM' />
                                    <button className={styles.button} onClick={() => refetch()}>
                                        <FormattedMessage id='BUTTON_LABEL_RETRY_FAILED' />
                                    </button>
                                </div>
                            </LoadingWrapperView>
                        );
                    }

                    return null;
                }}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(MySelectionLoader);
